import { render, staticRenderFns } from "./EnterFreeWishes.vue?vue&type=template&id=474ed400&scoped=true"
import script from "./EnterFreeWishes.vue?vue&type=script&lang=js"
export * from "./EnterFreeWishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ed400",
  null
  
)

export default component.exports